import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatDialog} from '@angular/material/dialog';
import {take} from 'rxjs/operators';
import { FileSelectorModel } from '../models/file-selector.model';

@Injectable({
  providedIn: 'root',
})

export class CreateEliteFormSetCommandHandler implements IPlatformCommandHandler {
  constructor(
    protected dialog: MatDialog,
    private dialogService: DialogService,
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const parentId = command.fieldValues['ParentId'] as string;
    const fileExtensionTypes = command.fieldValues['FileExtensionTypes'] as string[]; // [".frms"]
    const isClientDrive = command.fieldValues['IsClientDrive'] as boolean;
    const selectOnlyCurrentDirectoryFiles = command.fieldValues['SelectOnlyCurrentDirectoryFiles'] as boolean;
    if (parentId) {
      const fileSelector: FileSelectorModel = {
        parentId,
        isClientDrive,
        fileExtensionTypes,
        iconViewModels: [],
        selectOnlyCurrentDirectoryFiles
      };

      this.dialogService.showOrbitaxDriveFileSelector(fileSelector).subscribe(result => {
        if (result.action === 'OK') {
          this.dialogService.showTextInputDialog('Form Name', '').pipe(take(1)).subscribe(result2 => {
            if (result2.action === 'OK') {
              if (result2.data.input.text && result2.data.input.text.length > 0) {
                command.fieldValues['SelectedItems'] = result.data.input.selectedItems.map(item => item.itemId);
                command.fieldValues['Title'] = result2.data.input.text;
                command.fieldValues['ParentId'] = result.data.input.parentId;
                command.fieldValues['DriveId'] = result.data.input.selectedItems[0].driveId;
                handler.executeCommand(command);
                return true;
              }
            }
          });
        }
      });
    }
    return false;
  }
}
